export default function BeforeAfter() {
  const transformations = [
    {
      name: 'Maria Silva',
      weight: '5kg perdidos',
      before: 'https://public.readdy.ai/ai/img_res/bb791c9caca72aa90c10ab542b31a2f4.jpg',
      after: 'https://readdy.ai/api/search-image?query=fit%20woman%20after%20weight%20loss%20transformation%20standing%20front%20view%20athletic%20wear%20confident%20pose%20neutral%20simple%20white%20background%20professional%20photography%20realistic%20natural%20lighting%20full%20body%20portrait%20toned%20body&width=400&height=600&seq=after-001&orientation=portrait',
      testimonial: 'Incrível! Perdi 5kg e me sinto muito mais disposta e confiante.'
    },
    {
      name: 'João Santos',
      weight: '7kg perdidos',
      before: 'https://readdy.ai/api/search-image?query=man%20before%20weight%20loss%20transformation%20standing%20front%20view%20casual%20tshirt%20neutral%20simple%20white%20background%20professional%20photography%20realistic%20natural%20lighting%20full%20body%20portrait%20overweight&width=400&height=600&seq=before-002&orientation=portrait',
      after: 'https://readdy.ai/api/search-image?query=athletic%20man%20after%20weight%20loss%20transformation%20standing%20front%20view%20fitness%20clothes%20muscular%20definition%20neutral%20simple%20white%20background%20professional%20photography%20realistic%20natural%20lighting%20full%20body%20portrait%20fit%20body&width=400&height=600&seq=after-002&orientation=portrait',
      testimonial: 'Resultado surpreendente em apenas 10 dias. Recomendo muito!'
    },
    {
      name: 'Ana Costa',
      weight: '4kg perdidos',
      before: 'https://readdy.ai/api/search-image?query=young%20woman%20before%20weight%20loss%20standing%20front%20view%20comfortable%20clothing%20neutral%20simple%20white%20background%20professional%20photography%20realistic%20natural%20lighting%20full%20body%20portrait%20curvy%20body&width=400&height=600&seq=before-003&orientation=portrait',
      after: 'https://readdy.ai/api/search-image?query=slim%20woman%20after%20weight%20loss%20transformation%20standing%20front%20view%20sporty%20outfit%20happy%20expression%20neutral%20simple%20white%20background%20professional%20photography%20realistic%20natural%20lighting%20full%20body%20portrait%20lean%20body&width=400&height=600&seq=after-003&orientation=portrait',
      testimonial: 'Mudou minha relação com a comida. Estou muito feliz com os resultados!'
    }
  ];

  return (
    <section id="antes-depois" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-16 gap-8">
          <div>
            <h2 className="text-5xl md:text-6xl font-bold mb-2">
              <span className="text-gray-300">Resultados</span>
            </h2>
            <h3 className="text-5xl md:text-6xl font-serif italic text-gray-900">
              Antes & Depois
            </h3>
          </div>
          <div className="lg:w-2/5">
            <p className="text-lg text-gray-600 leading-relaxed">
              Veja as transformações reais de pessoas que aceitaram o desafio. 
              Resultados comprovados em apenas 10 dias com dedicação e o método certo.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {transformations.map((person, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-96 overflow-hidden rounded-3xl">
                <div className="absolute inset-0 flex">
                  <div className="w-1/2 h-full relative overflow-hidden">
                    <img 
                      src={person.before}
                      alt={`Antes - ${person.name}`}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      ANTES
                    </div>
                  </div>
                  <div className="w-1/2 h-full relative overflow-hidden">
                    <img 
                      src={person.after}
                      alt={`Depois - ${person.name}`}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4 bg-teal-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      DEPOIS
                    </div>
                  </div>
                </div>
                <div className="absolute inset-x-0 top-1/2 transform -translate-y-1/2 flex justify-center">
                  <div className="w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center">
                    <i className="ri-arrow-left-right-line text-xl text-gray-800"></i>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-sm font-bold mb-4">
                  10 DIAS
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2">
                  {person.name}
                </h4>
                <p className="text-xl font-semibold text-teal-600 mb-3">
                  {person.weight}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  "{person.testimonial}"
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-50 to-orange-100 px-8 py-4 rounded-2xl">
            <i className="ri-star-fill text-2xl text-orange-500"></i>
            <span className="text-lg font-semibold text-gray-800">
              Mais de <strong className="text-orange-600">2.500 pessoas</strong> já transformaram suas vidas
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
